import React, { useEffect, useState } from "react";
import loanPageStyle from "./loan.module.css";
import LoanleadForm from "./LoanleadForm";
import {
  APPLY_LOAN_APPLICATION_CTA,
  LOAN_BANNER_SUBHEADING,
  Loansteps,
  NEED_HELP_PHONE_TEXT,
  WhyChooseSection,
} from "../../constants/Constant";
import { useSelector } from "react-redux";
import { getSelectedEvent, getUser, isFetching } from "../../Redux/Reducer/AppReducer";

function LoanLandingPage() {
  
  const [width, setWidth] = useState(window.innerWidth);
  const event = useSelector(getSelectedEvent);
  const user = useSelector(getUser)
  const isFetchingUser = useSelector(isFetching)


  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const cardstyle = width > 768 ? { gridTemplateColumns: '1fr 1fr 1fr 1fr' } : {};

  return (
    <div style={{}}>
      <div className={loanPageStyle["wrapper-container"]}>
        <div className={loanPageStyle["banner-container"]}>
          <div className={loanPageStyle["left-container"]}>
            <p className={loanPageStyle["heading"]}>
              Fund Your Dream Wedding with <span>WeddingPe</span>
            </p>
            <p className={loanPageStyle["subheading"]}>
              {LOAN_BANNER_SUBHEADING}
            </p>
            {width > 768 && 
            <>
            
            <div className={loanPageStyle["button-container"]}>
              <button onClick={() => {}} className={loanPageStyle["view-btn"]}>
                <span className={loanPageStyle["View-button-text"]}>
                  {APPLY_LOAN_APPLICATION_CTA}
                </span>
              </button>
            </div>
        <a href={`tel:${'8279220676'}`} style={{textDecoration:'none'}}>
            <p
              className={loanPageStyle["subheading"]}
              style={{ marginTop: "40px" }}
            >
              {NEED_HELP_PHONE_TEXT}
            </p>
            </a>
            </>

}
          </div>
          <div className={loanPageStyle["cta-form-container"]}>
            <LoanleadForm user={user} event={event} isFetchingUser={isFetchingUser} width={width}/>
          </div>
        </div>
      </div>

      <div className={loanPageStyle["why-choose-section"]}>
        <p className={loanPageStyle["why-section-text"]}>
          Why Choose <span>WeddingPe</span>
        </p>
        <div className={loanPageStyle["card"]}>
          {WhyChooseSection.map((card, index) => (
            <div className={loanPageStyle["discover-container"]}>
              <div
                style={{
                  backgroundColor: "#FFAAC4",
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={`https://vmnk.gumlet.io/loan-card-image.png`}
                  className={loanPageStyle["loan-icon"]}
                  alt="image"
                />
              </div>
              <p className={loanPageStyle["discover-heading"]}>
                {card.heading}
              </p>
              <p className={loanPageStyle["discover-desc"]}>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={loanPageStyle["steps-section"]}>
        <p className={loanPageStyle["why-section-text"]}>
          Get Your <span>Wedding Loan</span> in 4 Easy Steps
        </p>

        <div className={loanPageStyle["steps-section-card"]} >
          {Loansteps.map((card, index) => (
            <div className={loanPageStyle["steps-container"]}>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
              <div
                style={{
                  backgroundColor: "#FFAAC4",
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p
                  className={loanPageStyle["corporate-card-number-text"]}
                  style={{ margin: 0 }}
                >
                  {index + 1}
                </p>
              </div>
              </div>
              <p className={loanPageStyle["card-heading"]}>
                {card.heading}
              </p>
              <p className={loanPageStyle["card-desc"]}>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LoanLandingPage;


// import React, { useState, useEffect } from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";

// function AddUpdateMember({ member, handleChange, errors }) {
//   const [phoneNumber, setPhoneNumber] = useState('');
//   const [phoneError, setPhoneError] = useState(null);

//   const handlePhoneNumberChange = (value) => {
//     setPhoneNumber(value);
//   };


//   const handleFieldChange = (field, value) => {
//     handleChange(field, value);

//     if (field === "firstName" || field === "lastName") {
//       const updatedContactName = `${field === "firstName" ? value : member.firstName || ""} ${
//         field === "lastName" ? value : member.lastName || ""
//       }`.trim();
//       handleChange("contactName", updatedContactName);
//     }
//   };

//   const showError = (keyName) => {
//     return errors && errors[keyName] ? (
//       <p className="text-red-500 text-[14px] pl-8 pt-2">{errors[keyName]}</p>
//     ) : null;
//   };

//   const printLabel = (text) => {
//     return (
//       <>
//         <span>{text}</span>
//         <span className="text-red-500">*</span>
//       </>
//     );
//   };

//   useEffect(() => {
//     // Phone number validation
//     const validatePhoneNumber = () => {
//       if (!phoneNumber) {
//         setPhoneError("Phone number is required.");
//       } else if (phoneNumber.length < 10 || phoneNumber.length > 15) {
//         setPhoneError("Phone number must be between 10 and 15 digits.");
//       } else {
//         setPhoneError(null); // No error if valid
//       }
//     };

//     validatePhoneNumber();
//   }, [phoneNumber]);

//   console.log(phoneNumber, "Phone Number");
//   console.log("Selected Country Code:", countryCode);

//   return (
//     <div style={{ padding: "24px", maxWidth: "480px", margin: "0 auto" }}>
//       <div style={{ marginBottom: "16px" }}>
//         <label
//           style={{
//             display: "block",
//             fontSize: "16px",
//             fontWeight: "600",
//             color: "#4B5563",
//             marginBottom: "8px",
//           }}
//         >
//           {printLabel("Phone Number")}
//         </label>
//         <PhoneInput
//           defaultCountry="US"
//           value={phoneNumber}
//           onChange={handlePhoneNumberChange}
//           placeholder="Enter phone number"
//           style={{
//             width: "100%",
//             border: "1px solid #D1D5DB",
//             borderRadius: "8px",
//             fontSize: "16px",
//             outline: "none",
//             boxSizing: "border-box",
//           }}
//         />
//         {phoneError && (
//           <p className="text-red-500 text-[14px] pl-8 pt-2">{phoneError}</p>
//         )}
//         {showError("phoneNumber")}
//       </div>

//       {/* Display Country Code and Phone Number */}
//       <h2>Country Code: {countryCode}</h2>
//       <h2>Phone Number: {phoneNumber}</h2>
//     </div>
//   );
// }

// export default AddUpdateMember;



// import React, { useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";

// const MyComponent = () => {
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [countryCode, setCountryCode] = useState("");

//   const handlePhoneNumberChange = (value, country) => {
//     debugger
//     setPhoneNumber(value);  // Set the phone number without the country code
//     setCountryCode(country.dialCode); // Set the selected country code
//   };

//   return (
//     <div>
//       <PhoneInput
//         defaultCountry="US"
//         value={phoneNumber}
//         disableCountryCode={true}
//         onChange={handlePhoneNumberChange}
//         placeholder="Enter phone number"
//         style={{
//           width: "100%",
//           border: "1px solid #D1D5DB",
//           borderRadius: "8px",
//           fontSize: "16px",
//           outline: "none",
//           boxSizing: "border-box",
//         }}
//       />

//       {/* Display the selected country code and phone number (without the country code) */}
//       <div>
//         <p>Country Code: {countryCode}</p>
//         <p>Phone Number (without country code): {phoneNumber}</p>
//       </div>
//     </div>
//   );
// };

// export default MyComponent;




// import React, { useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";

// const MyComponent = () => {
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const [countryCode, setCountryCode] = useState("");

//   const handlePhoneNumberChange = (value, country) => {
//     // The full phone number with country code
//     const fullPhoneNumber = value;
    
//     // The country code (dial code)
//     const dialCode = country.dialCode;

//     // Remove the country code from the phone number
//     const phoneWithoutCountryCode = fullPhoneNumber.replace(`+${dialCode}`, "");

//     // Update state with the phone number and country code
//     setPhoneNumber(phoneWithoutCountryCode.trim());  // Remove any leading or trailing spaces
//     setCountryCode(dialCode);
//   };

//   return (
//     <div>
//       <PhoneInput
//         defaultCountry="US"
//         value={phoneNumber}  // Combine the country code and phone number for display
//         disableCountryCode={true}
//         onChange={handlePhoneNumberChange}
//         placeholder="Enter phone number"
//         style={{
//           width: "100%",
//           border: "1px solid #D1D5DB",
//           borderRadius: "8px",
//           fontSize: "16px",
//           outline: "none",
//           boxSizing: "border-box",
//         }}
//       />

//       {/* Display the selected country code and phone number (without the country code) */}
//       <div>
//         <p>Country Code: {countryCode}</p>
//         <p>Phone Number (without country code): {phoneNumber}</p>
//       </div>
//     </div>
//   );
// };

// export default MyComponent;
